module.exports = __webpack_public_path__ + "img/placeholder.f84691bf.svg";